export default "__VITE_ASSET__B84W4x61__"